
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {State} from 'vuex-class'

@Component
export default class BaseLayout extends Vue {
  @State('user') public user!: string
  @State('isLogged') private isLogged!: boolean
  @Prop() private title!: string
}
